import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[700px] md:min-h-[820px] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20e-commerce%20conceptual%20background%20with%20geometric%20shapes%20in%20soft%20mint%20green%20and%20warm%20cream%20tones%2C%20featuring%20floating%20rounded%20rectangles%20representing%20product%20cards%2C%20clean%20modern%20aesthetic%2C%20subtle%20gradient%2C%20trendy%20editorial%20style%2C%20no%20text%2C%20smooth%20organic%20composition%2C%20light%20airy%20atmosphere%2C%20contemporary%20digital%20art&width=1800&height=1000&seq=hero-bg-cssbuy-01&orientation=landscape"
          alt="CSSBuy Spreadsheet modern aesthetic background"
          title="CSSBuy Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="mb-8 md:mb-10 flex justify-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-200/40 bg-background-50/10 backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
            <span className="text-xs md:text-sm font-medium text-background-50">Updated Daily &bull; 14+ Categories</span>
          </div>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-4 md:mb-6 animate-fade-in-up">
          CSSBuy Spreadsheet
        </h1>

        <p className="text-lg md:text-2xl text-background-50/80 font-light mb-3 animate-fade-in-up delay-100 max-w-2xl mx-auto">
          Your Ultimate Finds Hub on cssspreadsheet.study
        </p>

        <p className="text-sm md:text-base text-background-50/60 max-w-xl mx-auto mb-10 md:mb-12 animate-fade-in-up delay-200 leading-relaxed">
          Discover the most comprehensive CSSBuy spreadsheet collection online. Browse 14 product categories, access expert buying guides, and find the best quality picks — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up delay-300">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            cssbuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 border border-background-50/30 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            buy it now
          </a>
          <Link
            to="/article/cssbuy-sheet-complete-guide"
            className="w-full sm:w-auto px-8 py-3.5 text-background-50/90 rounded-full text-sm md:text-base font-medium hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-1.5"
          >
            Read Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}